export default "/images/vendor/flag-icon-css/flags/4x3/bo.svg?1155c3da4861424ea8ffa53c51854847";